import axios from "axios";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { grey, teal } from '@material-ui/core/colors';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons";

import * as comMod from '../../commonModule'; 
import { menuItems } from '../../DrowerMenu';
import { LoadingSpinner } from "../common/commonParts";
import BlogFeed from './BlogFeed';
import { useH2Style } from "./BlogFeed";
import { endPoint } from "../../albCommonModule";
import SchSelectMonth from "../schedule/SchSelectMonth";
const useStyles = makeStyles({

  headerMenu: {
    marginBottom: 16,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    '& .icon':{
      width: '80px',
      textAlign: 'center',
      color: teal[500],
      margin: 10,
      '& .MuiSvgIcon-root':{
        fontSize: 36,
      }
    },
    '& .is-empty':{
      '@media (max-width: 1220px)':{
        width: '100px',
        margin: 4,
      },
      width: 0,
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: 0,
      marginBottom: 0,
    }
  },
  headerMenuTest:{
    width: '100%',
    marginBottom: "32px",
    '& .iconContents':{
      width: '80%',
      margin: '0 auto',
      display: 'flex',
      flexWrap: 'wrap',
      '& .icon':{
        minWidth: 100,
        width: '10%',
        textAlign: 'center',
        color: teal[500],
        margin: '4px 0',
        '& .MuiSvgIcon-root':{
          fontSize: 36,
        }
      },
    },
  },
  houdayNewsContents:{
    margin: '10px auto',
    maxWidth: '904px',
    '& .card': {
      "@media (max-width: 620px)": {
        height: '100px',
      },
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '56px',
      padding: '8px',
      textDecoration: 'none',
      color: '#111',
      '& .main': {
        height: '90%',        
        display: 'flex',
        justifyContent: 'space-between',
        '& .text': {
          display: 'flex',
          flexDirection: 'column',
          paddingRight: '5px',
          '& .title': {
            marginBottom: '16px',
            fontSize: '18px',
            fontWeight: '500',
          },
          '& .about': {
            fontSize: '14px',
            color: grey[800],
            lineHeight: '1.6',
            "@media (max-width: 620px)": {
              display: 'none',
            }
          },
        },
        '& .img': {
          height: '112px',
          width: '112px',
          margin: '0 auto',
          "@media (max-width: 620px)": {
            width: '15%',
            height: 'auto',
          }
        },
      },

      '& .sub': {
        display: 'flex',
        fontSize: '12px',
        paddingTop: '16px',
        color: grey[600],
        alignItems: 'center',
        '& img': {
          marginRight: '5px',
        },
        '& div': {
          marginRight: '5px',
        },
      },
    },
    '& a:hover .title':{
      textDecoration: 'underline',
    },
  },
})

const HaderMenu = () => {
  const classes = useStyles();
  const hist = useHistory();
  const account = useSelector(state=>state.account);
  const [permission, setPermission] = useState(0);
  useEffect(()=>{
    setPermission(comMod.parsePermission(account)[0][0]);
  },[account]);
  // menuItemsにhidStrを追加したため変更　2023/01/05　吉村
  const {hid} = account;
  const fMenuItems = menuItems.filter(e=>e.p<=permission)
  .filter(e=>(!e.hidStr || e.hidStr.split(',').includes(hid)));
  // const icon_link = menuItems.filter(e=>e.p<=permission).map((item, index) => {
  const icon_link = fMenuItems.map((item, index) => {
    if (item.hids && !item.hids.includes(account.hid)) return null;
    if(item.label === "予定実績登録"){
      const fontAwesomeIconStyle = { fontSize: 30, padding: '3 4.875', marginBottom: 2};
      return(
        <a className='icon textEclips' onClick={e => hist.push(item.link)} key={"menu"+String(index)}>
          <FontAwesomeIcon icon={faCalendarAlt} style={fontAwesomeIconStyle} />
          <p style={{color: '#111', marginTop: 12}}>{item.label}</p>
        </a>
      )
    }
    return(
      <a className='icon textEclips' onClick={e => hist.push(item.link)} key={"menu"+String(index)}>
        {item.icon}
        <p style={{color: '#111', marginTop: 12}}>{item.label}</p>
      </a>
    )
  })

  return(
    <div className={classes.headerMenu}>
      {icon_link}
    </div>
  )
}

const HoudayNewsMain = (props) => {
  const h2classes = useH2Style();
  const classes = useStyles();
  const {newsDt} = props;
  const news_box = newsDt.map((x,index) => {
    return(
      <a className={"card"} href={x.url} key={"card"+String(index)}>
        <div className={"main"}>
          <div className={"text"}>
            <div className={"title"}>{x.title}</div>
            <div className={"about"}>{x.about}</div>
            <div className={"sub"}>
              <img className={"icon"} src={x.iconUrl} />
              <div className={"name"}>{x.name}</div>
            </div>
          </div>
          {x.imgUrl ?<img className={"img"} src={x.imgUrl} /> :null}
        </div>
      </a>
    )
  });

  if(news_box.length === 0){
    return(
      <div>ニュース情報の取得に失敗しました。</div>
    )
  }
  return(
    <div className={classes.houdayNewsContents}>
      <h2 className={h2classes.feedHeader}>福祉ニュース</h2>{news_box}
    </div>
  )
}

const HoudayNews = () => {
  const [newsDt, setNewsDt] = useState([]);
  useState(() => {
    if(newsDt.length) return;
    let isMounted = true;
    if(isMounted && !newsDt.length){
      (async() => {
        const parms = {a: "fetchSomeState", jino: "9999999999", item: "houdayNews"};
        await axios.post(endPoint(), comMod.makeUrlSearchParams(parms)).then(res => {
          const feed_dtlist = res.data.dt[0] ?res.data.dt[0].state :false;
          if(isMounted && feed_dtlist) setNewsDt(feed_dtlist);
        })
      })();
    }
  return ()=>{
    isMounted = false;
  }
  }, [])

  return (
    <div className='AppPage houdayNews'>
      <HaderMenu />
      <SchSelectMonth />
      <BlogFeed />
      {newsDt.length ?<HoudayNewsMain newsDt={newsDt} /> :<LoadingSpinner/>}
    </div>
  )
}
export default HoudayNews;